import { render } from "./ModalHeader.vue?vue&type=template&id=4000d170&scoped=true"
import script from "./ModalHeader.vue?vue&type=script&lang=js"
export * from "./ModalHeader.vue?vue&type=script&lang=js"

import "./ModalHeader.vue?vue&type=style&index=0&id=4000d170&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4000d170"]])

export default __exports__